import { TableBody as MUITableBody } from '@mui/material';
import { Props } from '../../models/Props.types';

export default function TableBody(props: Props) {
    return <MUITableBody>{props.children}</MUITableBody>;
}
